import script from "./TermsContentRommeMasters.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsContentRommeMasters.vue?vue&type=script&setup=true&lang=ts"

import "./TermsContentRommeMasters.vue?vue&type=style&index=0&id=7eb20526&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb20526"]])

export default __exports__